<div class="dialog-vc-signature">
    <h1>Beitrittsanfrage signieren</h1>
    <div mat-dialog-content>
        <p class="description">Sie müssen Ihre Beitrittsanfrage digital signieren, damit diese weiterverarbeitet werden kann. Bitte wählen Sie hierfür den privaten Schlüssel zur DID {{ data.did }} aus.</p>
        <div class="upload-key">
            <input #keyFileInput type="file" (change)="onKeyUpload($event)" accept=".pem" class="input" />
            <div class="zone" [class.zone-has-file]="keyFileName" (click)="keyFileInput.click()">
              @if(!keyFileName) {
                <ng-container>
                  <mat-icon class="icon">cloud_upload</mat-icon>
                  <span class="label">Schlüssel hochladen</span>
                  <span class="hint">.pem — Klicken oder Datei hierher ziehen</span>
                </ng-container>
              }
              @else {
                <ng-container>
                  <mat-icon class="icon icon-success">check_circle</mat-icon>
                  <span class="label">{{ keyFileName }}</span>
                  <button type="button" class="clear" (click)="clearKeyFile(); $event.stopPropagation()"
                    matTooltip="Datei entfernen">
                    <mat-icon>close</mat-icon>
                  </button>
                </ng-container>
              }
            </div>
          </div>
    </div>
    <div class="actions" mat-dialog-actions>
        <app-span-button [label]="'Abbrechen'" [cancel]="true" (click)="onClose()"></app-span-button>
        <app-span-button [label]="'Signieren und Absenden'" [disabled]="!keyFile" (click)="onConfirm()"></app-span-button>
    </div>
</div>